module.exports = __webpack_public_path__ + "static/media/prenetalPrep.6fe3c107.svg";